/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ModuleDto } from './ModuleDto';
export type CourseDetails = {
    id?: string;
    agentId?: string;
    title?: string;
    modules?: Array<ModuleDto>;
    language?: CourseDetails.language;
    createdAt?: string;
};
export namespace CourseDetails {
    export enum language {
        EN = 'EN',
        DE = 'DE',
    }
}

